import { PatientComplement } from "../../components/PatientComplement/PatientComplement";

export const PatientComplementPage = () => {
  return (
    <div>
      <h1>Hledání konkrétního pacienta dle laboratorních výsledkú</h1>

      <PatientComplement careType="hospitalization" />
    </div>
  );
};
